import {sharedDropdownContent} from 'components/Dropdown/styles'

export const dropdownNestedMenuContentWrapper = {
    ...sharedDropdownContent,
    display: 'none',
    padding: '6px',
    zIndex: '$dropdownNestedMenu',
    // eslint-disable-next-line sort-keys
    compoundVariants: [{
        css: {
            left: '-10px',
            top: '-12px',
            transform: 'translate(-100%, 0)',
        },
        direction: 'left',
        open: true,
    }, {
        css: {
            right: '-10px',
            top: '-12px',
            transform: 'translate(100%, 0)',

        },
        direction: 'right',
        open: true,
    }],
    variants: {
        direction: {
            left: {},
            right: {},
        },
        open: {true: {display: 'block'}},
    },
}
